const Title = ({ label }) => {
    return (
        <div className="bg-midnight-200 py-2 px-6 text-white rounded-lg mb-2">
            {label}
        </div>
    )
}

export default Title;